import PrimaryButton from "components/button/billing_button";
import TertiaryButton from "components/button/tertiaty_button";
import { Body2 } from "components/text/body/style";
import { useEffect, useState } from "react";
import billing_theme from "style/theme_colors";
import { NewModeloContent, NewModeloDetails } from "./style";
import BillingTextInput from "components/input/text_input";
import BillingTextArea from "components/input/text_area";
import LineSkeleton from "components/skeleton/line_skeleton";
import useBillingEnum from "hooks/useBillingEnum";
import { RootState } from "store/store";
import { useSelector } from "react-redux";
import BillingSelectInput from "components/input/select";
import useNewModelo from "hooks/useNewModelo";

const ModalNewModelo: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const [nome, setNome] = useState<string>();
  const [descricao, setDescricao] = useState<string>();
  const [idEquipamento, setIdEquipamento] = useState<string>();
  const { addNewModelo, isLoadingModelo } = useNewModelo();
  const { getEnums, isLoadingEnum } = useBillingEnum();
  const enumList = useSelector((state: RootState) => state.list_enum);
  useEffect(() => {
    getEnums();
  }, []);

  return (
    <NewModeloContent>
      <NewModeloDetails>
        <Body2 fontWeight={600} color={billing_theme.pallete.tertiary?.A400}>
          Nome:
        </Body2>
        {isLoadingEnum || isLoadingModelo ? (
          <LineSkeleton width={"100%"} height={40} />
        ) : (
          <BillingTextInput
            placeholder="Qual o nome do serviço?"
            change={value => {
              setNome(value);
            }}
          />
        )}
      </NewModeloDetails>
      <NewModeloDetails>
        <Body2 fontWeight={600} color={billing_theme.pallete.tertiary?.A400}>
          Tipo de equipamento:
        </Body2>
        {isLoadingEnum || isLoadingModelo ? (
          <LineSkeleton width={"100%"} height={40} />
        ) : (
          <BillingSelectInput
            onChange={(val: any) => {
              val != null ? setIdEquipamento(val?.value!) : setIdEquipamento("");
            }}
            options={enumList.TipoEquipamentoOptions!}
            placeholder={"Qual o tipo de equipamento?"}
          />
        )}
      </NewModeloDetails>
      <NewModeloDetails>
        <Body2 fontWeight={600} color={billing_theme.pallete.tertiary?.A400}>
          Quantidade:
        </Body2>

        {isLoadingEnum || isLoadingModelo ? (
          <LineSkeleton width={"100%"} height={100} />
        ) : (
          <BillingTextArea
            placeholder="Dê uma descrição do modelo!"
            change={value => {
              setDescricao(value);
            }}
            lines={3}
          />
        )}
      </NewModeloDetails>

      <div className="button">
        <TertiaryButton label={"Cancelar"} onTap={onClose} isSmall />
        <PrimaryButton
          disable={nome == undefined || idEquipamento == undefined || isLoadingModelo}
          label={"Salvar"}
          onTap={async () => {
            await addNewModelo({
              Nome: nome!,
              ID: 0,
              TipoEquipamento: Number(idEquipamento),
              Descricao: descricao,
            });
            onClose();
          }}
          isSmall
        />
      </div>
    </NewModeloContent>
  );
};

export default ModalNewModelo;
